<main id="main">

    <!-- ======= Breadcrumbs ======= -->
    <div class="breadcrumbs" data-aos="fade-in">
      <div class="container">
        <h2>Android Apps</h2>
      </div>
    </div><!-- End Breadcrumbs -->

    <!-- ======= Events Section ======= -->
    <section id="events" class="events">
      <div class="container" data-aos="fade-up">

        <div class="row">
          <div class="col-md-6 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/apps/mahanubhav_anvay.png" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title ">Mahanubhav Anvay Android App</h5>
                <p class="fst-italic text-center marathi-font">महानुभाव अन्वय अँप</p>
                <p class="text-center">Total Downloads: {{downloads.anvayAppDownloads}}</p>
                <p class="text-center"><button class="get-started-btn border-0" (click)="download(3)" ><i class="bi bi-download"></i>  Download</button></p>
              </div>
            </div>
          </div>
          <div class="col-md-6 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/apps/sarvadhnya.com.png" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title ">Sarvadhnya.com Android App</h5>
                <p class="fst-italic text-center marathi-font">सर्वज्ञ डॉटकॉम अँप</p>
                <p class="text-center">Total Downloads: {{downloads.sarvadhnyaAppDownload}}</p>
                <p class="text-center"><button class="get-started-btn border-0"  (click)="download(4)"><i class="bi bi-download"></i> Download</button></p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section><!-- End Events Section -->

  </main><!-- End #main -->